{
    "name": "Elegoo",
    "version": "01.10.00.01",
    "force_update": "0",
    "description": "Elegoo configurations",
    "machine_model_list": [
        {
            "name": "Elegoo Neptune",
            "sub_path": "machine/Elegoo Neptune.json"
        },
        {
            "name": "Elegoo Neptune X",
            "sub_path": "machine/Elegoo Neptune X.json"
        },
        {
            "name": "Elegoo Neptune 2",
            "sub_path": "machine/Elegoo Neptune 2.json"
        },
        {
            "name": "Elegoo Neptune 2S",
            "sub_path": "machine/Elegoo Neptune 2S.json"
        },
        {
            "name": "Elegoo Neptune 2D",
            "sub_path": "machine/Elegoo Neptune 2D.json"
        },
        {
            "name": "Elegoo Neptune 3",
            "sub_path": "machine/Elegoo Neptune 3.json"
        },
        {
            "name": "Elegoo Neptune 3 Pro",
            "sub_path": "machine/Elegoo Neptune 3 Pro.json"
        },
        {
            "name": "Elegoo Neptune 3 Plus",
            "sub_path": "machine/Elegoo Neptune 3 Plus.json"
        },
        {
            "name": "Elegoo Neptune 3 Max",
            "sub_path": "machine/Elegoo Neptune 3 Max.json"
        },
        {
            "name": "Elegoo Neptune 4",
            "sub_path": "machine/Elegoo Neptune 4.json"
        },
        {
            "name": "Elegoo Neptune 4 Max",
            "sub_path": "machine/Elegoo Neptune 4 Max.json"
        },
        {
            "name": "Elegoo Neptune 4 Plus",
            "sub_path": "machine/Elegoo Neptune 4 Plus.json"
        },
        {
            "name": "Elegoo Neptune 4 Pro",
            "sub_path": "machine/Elegoo Neptune 4 Pro.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "fdm_process_elegoo_common",
            "sub_path": "process/fdm_process_elegoo_common.json"
        },
        {
            "name": "fdm_process_neptune4_common",
            "sub_path": "process/fdm_process_neptune4_common.json"
        },
        {
            "name": "fdm_process_neptune4max_common",
            "sub_path": "process/fdm_process_neptune4max_common.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo NeptuneX",
            "sub_path": "process/0.08mm Extra Fine @Elegoo NeptuneX.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune2",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune2.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune2S",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune2S.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune2D",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune2D.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune3",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune3.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune3Pro",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune3Pro.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune3Plus",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune3Plus.json"
        },
        {
            "name": "0.08mm Extra Fine @Elegoo Neptune3Max",
            "sub_path": "process/0.08mm Extra Fine @Elegoo Neptune3Max.json"
        },
        {
            "name": "0.10mm Standard @Elegoo Neptune4 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @Elegoo Neptune4 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Standard @Elegoo Neptune4Max 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @Elegoo Neptune4Max 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Standard @Elegoo Neptune4 Plus 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @Elegoo Neptune4 Plus 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune.json"
        },
        {
            "name": "0.12mm Fine @Elegoo NeptuneX",
            "sub_path": "process/0.12mm Fine @Elegoo NeptuneX.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune2",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune2.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune2S",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune2S.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune2D",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune2D.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune3",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune3.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune3Pro",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune3Pro.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune3Plus",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune3Plus.json"
        },
        {
            "name": "0.12mm Fine @Elegoo Neptune3Max",
            "sub_path": "process/0.12mm Fine @Elegoo Neptune3Max.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo NeptuneX",
            "sub_path": "process/0.16mm Optimal @Elegoo NeptuneX.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune2",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune2.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune2S",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune2S.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune2D",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune2D.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune3",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune3.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune3Pro",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune3Pro.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune3Plus",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune3Plus.json"
        },
        {
            "name": "0.16mm Optimal @Elegoo Neptune3Max",
            "sub_path": "process/0.16mm Optimal @Elegoo Neptune3Max.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune.json"
        },
        {
            "name": "0.20mm Standard @Elegoo NeptuneX",
            "sub_path": "process/0.20mm Standard @Elegoo NeptuneX.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune2",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune2.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune2S",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune2S.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune2D",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune2D.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune3",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune3.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune3Pro",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune3Pro.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune3Plus",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune3Plus.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune3Max",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune3Max.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune4 0.4 nozzle",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune4 0.4 nozzle.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune4Max 0.4 nozzle",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune4Max 0.4 nozzle.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune4 Plus 0.4 nozzle",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune4 Plus 0.4 nozzle.json"
        },
        {
            "name": "0.20mm Standard @Elegoo Neptune4Pro 0.4 nozzle",
            "sub_path": "process/0.20mm Standard @Elegoo Neptune4Pro 0.4 nozzle.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune.json"
        },
        {
            "name": "0.24mm Draft @Elegoo NeptuneX",
            "sub_path": "process/0.24mm Draft @Elegoo NeptuneX.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune2",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune2.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune2S",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune2S.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune2D",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune2D.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune3",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune3.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune3Pro",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune3Pro.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune3Plus",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune3Plus.json"
        },
        {
            "name": "0.24mm Draft @Elegoo Neptune3Max",
            "sub_path": "process/0.24mm Draft @Elegoo Neptune3Max.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo NeptuneX",
            "sub_path": "process/0.28mm Extra Draft @Elegoo NeptuneX.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune2",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune2.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune2S",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune2S.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune2D",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune2D.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune3",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune3.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune3Pro",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune3Pro.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune3Plus",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune3Plus.json"
        },
        {
            "name": "0.28mm Extra Draft @Elegoo Neptune3Max",
            "sub_path": "process/0.28mm Extra Draft @Elegoo Neptune3Max.json"
        },
        {
            "name": "0.30mm Standard @Elegoo Neptune4 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Elegoo Neptune4 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Elegoo Neptune4Max 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Elegoo Neptune4Max 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Elegoo Neptune4 Plus 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Elegoo Neptune4 Plus 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Elegoo Neptune4Pro 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Elegoo Neptune4Pro 0.6 nozzle.json"
        },
        {
            "name": "0.40mm Standard @Elegoo Neptune4 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Elegoo Neptune4 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @Elegoo Neptune4Max 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Elegoo Neptune4Max 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @Elegoo Neptune4 Plus 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Elegoo Neptune4 Plus 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @Elegoo Neptune4Pro 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Elegoo Neptune4Pro 0.8 nozzle.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "Generic ABS @Elegoo",
            "sub_path": "filament/Generic ABS @Elegoo.json"
        },
        {
            "name": "Generic PETG @Elegoo",
            "sub_path": "filament/Generic PETG @Elegoo.json"
        },
        {
            "name": "Generic PLA @Elegoo",
            "sub_path": "filament/Generic PLA @Elegoo.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "fdm_elegoo_common",
            "sub_path": "machine/fdm_elegoo_common.json"
        },
        {
            "name": "fdm_neptune_4_common",
            "sub_path": "machine/fdm_neptune_4_common.json"
        },
        {
            "name": "Elegoo Neptune 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune X 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune X 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 2 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 2 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 2S 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 2S 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 2D 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 2D 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 3 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 3 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 3 Pro 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 3 Pro 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 3 Plus 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 3 Plus 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 3 Max 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 3 Max 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 0.2 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 0.2 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 0.6 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 0.6 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 0.8 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 0.8 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Max 0.2 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Max 0.2 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Max 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Max 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Max 0.6 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Max 0.6 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Max 0.8 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Max 0.8 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Plus 0.2 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Plus 0.2 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Plus 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Plus 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Plus 0.6 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Plus 0.6 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Plus 0.8 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Plus 0.8 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Pro 0.2 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Pro 0.2 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Pro 0.4 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Pro 0.4 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Pro 0.6 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Pro 0.6 nozzle.json"
        },
        {
            "name": "Elegoo Neptune 4 Pro 0.8 nozzle",
            "sub_path": "machine/Elegoo Neptune 4 Pro 0.8 nozzle.json"
        }
    ]
}
